export const WaveForm = () => {
  const bars = [];

  for (let i = 0; i < 50; i++) {
    bars.push(<div key={i} className={"waveform__bar"} />);
  }

  return (
    <div data-cy="audio-waveform" className={"waveform"}>
      {bars}
    </div>
  );
};
